import { render, staticRenderFns } from "./detailStaffVariation.vue?vue&type=template&id=2acd22d6&scoped=true&"
import script from "./detailStaffVariation.vue?vue&type=script&lang=js&"
export * from "./detailStaffVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd22d6",
  null
  
)

export default component.exports